<template>
  <gg-card>
    <gg-card-header>
      Website Name
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <p>What is the name of your {{ websitetype }}?</p>
          <gg-text-field
            v-model="name"
            label="Name"
            data-vv-name="ws_name"
            data-vv-as="Name"
            v-validate="'required'"
            name="ws_name"
            :error-messages="errors.collect('ws_name')"
          />
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'WebsiteName',
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      starterSite: 'wizard_model/starterSite'
    }),
    name: {
      get () {
        return this.starterSite.website_name
      },
      set (val) {
        this.setName(val)
      }
    },
    websitetype: {
      get () {
        return this.starterSite.website_type !== 'Other' ? this.starterSite.website_type : 'Other Website'
      }
    }
  },
  methods: {
    ...mapMutations({
      setName: 'wizard_model/SET_SS_WEBSITE_NAME'
    }),
    validate () {
      return this.$validator.validateAll()
    }
  }
}
</script>

<style scoped>

</style>
